import {
  call,
  put,
  all,
  spawn,
  takeEvery,
  debounce,
  takeLatest,
} from 'redux-saga/effects';

import { AUDIT_HEADER } from 'utils/constants';
import { getItemFromLocalStorage } from 'utils/common';
import {
  VENDOR_DATA_BY_ID_URL,
  ADD_MONEY_TO_WALLET_URL,
  GET_WALLET_STATUS_URL,
  CREATE_FREE_TRIAL_WALLET_URL,
  ACTIVATE_INSTANT_REFUND_URL,
} from '../../constants/url';
import request from '../../utils/request';
import { showToast } from '../Toast/actions';
import {
  disableLoaderAction,
  saveVendorResponse,
  saveMaximumRefundAction,
} from './actions';
import {
  CREATE_REFUND,
  CREATE_REFUND_URL,
  VENDOR_DATA,
  MAXIMUM_REFUND_AMOUNT,
  MAXIMUM_REFUND_URL,
  INSTANT_REFUND_ELIGIBILITY_URL,
  INSTANT_REFUND_ELIGIBILITY,
  GET_WALLET_STATUS,
  GET_RECHARGE_ACCOUNT_DETAILS,
  UPDATE_DEFAULT_REFUND_SPEED,
  CREATE_INSTANT_REFUNDS_FREE_TRIAL_WALLET,
  GET_OBPP_STATUS,
  OBPP_STATUS,
} from './constants';

export function* createRefund({ data: { data, cb, actions } }: any) {
  try {
    const { url, method } = CREATE_REFUND_URL;
    const options = {
      headers: { 'Content-type': 'application/json' },
      method,
      body: JSON.stringify(data),
    };
    const response = yield call(request, url, options);
    // console.log('response from saga is - ', response);
    cb(response);
  } catch (err) {
    actions.setSubmitting(false);
    // if (errorCb) errorCb();
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* getVendorsData({ data: { vendorSplitData, errorCb } }: any) {
  try {
    const { url, method } = VENDOR_DATA_BY_ID_URL;
    const promiseArr = vendorSplitData.map(vendor => {
      const updatedUrl = url.replace('$vendor_id$', vendor.vendorId);
      const options = {
        method,
      };
      // eslint-disable-next-line redux-saga/yield-effects
      return call(request, updatedUrl, options);
    });
    const response = yield all(promiseArr);
    yield put(saveVendorResponse(response));
  } catch (err) {
    if (errorCb) errorCb();
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getMaximumRefundData({ data: { txId, errorCb, cb } }: any) {
  try {
    const { url, method } = MAXIMUM_REFUND_URL;
    const updatedUrl = url.replace('$tx_id$', txId);
    const options = {
      method,
    };
    const response = yield call(request, updatedUrl, options);
    cb(response);
    yield put(saveMaximumRefundAction(response));
  } catch (err) {
    if (errorCb) errorCb();
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getInstantRefundEligibility({
  data: { transactionId, refundAmount, cb, errorCb },
}: any) {
  try {
    const { url, method } = INSTANT_REFUND_ELIGIBILITY_URL;
    const options = {
      queryString: { transactionId, refundAmount },
      method,
    };
    const response = yield call(request, url, options);
    cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    if (errorCb) errorCb();
    // yield put(showToast(err));
  }
}

export function* getWalletStatus({ data: { successCb, callbackFn } }: any) {
  try {
    const { url, method } = GET_WALLET_STATUS_URL;
    const response = yield call(request, url, { method });
    successCb(response);
  } catch (err) {
    successCb({});
  } finally {
    if (callbackFn) callbackFn();
  }
}

export function* getRechargeAccountDetails({ data: { cb, errorCb } }: any) {
  try {
    const { url, method } = ADD_MONEY_TO_WALLET_URL;
    const response = yield call(request, url, { method });
    cb(response);
  } catch (err) {
    yield put(
      showToast(
        'Your account balance is less than the refund amount. Please recharge your account and try again',
      ),
    );
    errorCb();
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* updateDefautRefundSpeed({ data: { cb } }: any) {
  try {
    const payload = {
      configKey: 'DEFAULT_REFUND_SPEED',
      configValue: 'INSTANT',
    };

    const { url, method } = ACTIVATE_INSTANT_REFUND_URL;

    const options = {
      method,
      body: JSON.stringify(payload),
      headers: { [AUDIT_HEADER]: 'settings-preferences' },
    };
    yield call(request, url, options);
    cb();
  } catch (err) {
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* createInstantRefundsFreeTrialWallet({ data: { cb } }: any) {
  try {
    const { url, method } = CREATE_FREE_TRIAL_WALLET_URL;
    yield call(request, url, {
      method,
      queryString: { merchantId: getItemFromLocalStorage('merchantId') },
    });
    cb();
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getObppStatus({ data: { cb, errorCb } }: any) {
  try {
    const { url, method } = GET_OBPP_STATUS;
    const response = yield call(request, url, {
      method,
      queryString: { configKey: 'OBPP_MERCHANT' },
    });
    if (cb) cb(response);
  } catch (err) {
    if (errorCb) errorCb();
    yield put(showToast('Failed to fetch OBPP status'));
  }
}

function* debouncegetInstantRefundEligibility() {
  yield debounce(1000, INSTANT_REFUND_ELIGIBILITY, getInstantRefundEligibility);
}

export function* createRefundSaga() {
  yield takeEvery(CREATE_REFUND, createRefund);
}

export function* updateDefaultRefundSpeedSaga() {
  yield takeEvery(UPDATE_DEFAULT_REFUND_SPEED, updateDefautRefundSpeed);
}

export function* getVendorSaga() {
  yield takeEvery(VENDOR_DATA, getVendorsData);
}

export function* getMaximumRefundSaga() {
  yield takeEvery(MAXIMUM_REFUND_AMOUNT, getMaximumRefundData);
}

export function* getInstantRefundEligibilitySaga() {
  yield takeEvery(INSTANT_REFUND_ELIGIBILITY, getInstantRefundEligibility);
}

export function* getWalletStatusSaga() {
  yield takeLatest(GET_WALLET_STATUS, getWalletStatus);
}

export function* getRechargeAccountDetailsSaga() {
  yield takeLatest(GET_RECHARGE_ACCOUNT_DETAILS, getRechargeAccountDetails);
}

export function* getObppStatusSaga() {
  yield takeLatest(OBPP_STATUS, getObppStatus);
}
export function* createInstantRefundsFreeTrialWalletSaga() {
  yield takeLatest(
    CREATE_INSTANT_REFUNDS_FREE_TRIAL_WALLET,
    createInstantRefundsFreeTrialWallet,
  );
}

// Individual exports for testing
export default function* initiateRefundModalV2Saga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    createRefundSaga,
    getVendorSaga,
    getMaximumRefundSaga,
    getWalletStatusSaga,
    debouncegetInstantRefundEligibility,
    getRechargeAccountDetailsSaga,
    updateDefaultRefundSpeedSaga,
    createInstantRefundsFreeTrialWalletSaga,
    getObppStatusSaga,
    // saga2,
    // saga3,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
